// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import thumbsDownIcon from "@/assets/icons/thumbs-down.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type ThumbsDownIconProps = Omit<IconProps, "name">;

export function ThumbsDownIcon(props: ThumbsDownIconProps): React.ReactNode {
  return <Icon name={thumbsDownIcon} {...props} />;
}
